import { forwardRef } from "react";

import Select, { Props as SelectProps } from "./Select";

type Props = Omit<SelectProps, "options">;

export enum HANDS {
  RIGHT = "right",
  LEFT = "left",
}

const DominantHandSelect = forwardRef<HTMLButtonElement, Props>(
  ({ ...props }: Props, ref) => {
    const OPTIONS = [
      {
        value: HANDS.RIGHT,
        label: "Derecho",
      },
      {
        value: HANDS.LEFT,
        label: "Izquierdo",
      },
    ];

    return (
      <Select
        {...props}
        ref={ref}
        placeholder="Seleccionar..."
        options={OPTIONS}
      />
    );
  },
);

DominantHandSelect.displayName = "DominantHandSelect";

export default DominantHandSelect;
